import { render } from "./basic_button_link.vue?vue&type=template&id=40436d06&ts=true"
import script from "./basic_button_link.vue?vue&type=script&lang=ts"
export * from "./basic_button_link.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__